module.exports = __webpack_public_path__ + "media/images/icons/chevron-up-dae76b5d7f08c6bc3a917712e4a06a71.svg";